module.exports = __webpack_public_path__ + "media/images/black_history_month/doller-cd6c411f47dc45b7d070281a91850b94.svg";